export enum NOT_AUTHORIZED_TO_WORK_IN_US_TYPE {
  NO,
  YES,
}

export enum REQUIRE_VISA_SPONSORSHIP {
  NO,
  YES,
}
